<template>
  <v-row style="height: 100%">
    <v-col cols="12" class="text-center pt-0 pb-0">
      <div
        class="progress-circle"
        :style="{
          'font-size': size + 'px',
        }"
      >
        <span class="display font-weight-medium">{{ progress.toFixed(0) }}%</span>
        <div
          class="left-half-clipper"
          :class="{
            over50: progress > 50,
          }"
        >
          <div class="first50-bar" />
          <div
            class="value-bar"
            :style="{
              transform: `rotate(${progress * 3.6}deg)`,
            }"
          />
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';

const componentOptions: ComponentOptions = {
  name: 'AchievementComponent',
  props: {
    progress: {
      type: Number,
      required: true,
    },
    progress2: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      required: false,
      default: 20,
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.color-light-black {
  color: #333;

  @media only screen and (min-width: 500px) and (max-width: 768px) {
    font-size: 16px !important;
  }
}

h4.pct-of-recommended {
  @media only screen and (max-width: 599px) {
    display: block !important;
    font-size: 14px;
    margin-bottom: 16px;
  }
}

h3.your-coverage {
  @media only screen and (max-width: 599px) {
    display: block !important;
    font-size: 18px !important;
    margin-bottom: 4px;
  }
}

.top-row {
  @media only screen and (max-width: 599px) {
    width: 100% !important;
  }
}

.progress-circle {
  display: inline-block;
  position: relative;
  padding: 0;
  width: 9em;
  height: 9em;
  background-color: #868686;
  border-radius: 50%;
  line-height: 9em;

  @media only screen and (min-width: 500px) and (max-width: 768px) {
    span.display {
      font-size: 1.7em;
      line-height: 5.25em;
      width: 5.25em;
      background-size: 65%;
    }
  }

  &:after {
    z-index: 3;
    border: none;
    position: absolute;
    top: 0.5em;
    left: 0.5em;
    text-align: center;
    display: block;
    border-radius: 50%;
    width: 8em;
    height: 8em;
    background-color: #7a7a7a;
    content: ' ';
  }

  .left-half-clipper {
    z-index: 1;
    border-radius: 50%;
    width: 9em;
    height: 9em;
    position: absolute;
    clip: rect(0, 9em, 9em, 4.5em);

    .value-bar {
      position: absolute;
      clip: rect(0, 4.5em, 9em, 0);
      width: 9em;
      height: 9em;
      border-radius: 50%;
      border: 0.5em solid #56a4dd;
      box-sizing: border-box;
    }

    .first50-bar {
      position: absolute;
      clip: rect(0, 9em, 9em, 4.5em);
      background-color: #56a4dd;
      border-radius: 50%;
      width: 9em;
      height: 9em;
    }

    &.over50 {
      clip: rect(auto, auto, auto, auto) !important;
    }

    &:not(.over50) {
      .first50-bar {
        background-color: #868686 !important;
      }
    }
  }

  > .display {
    position: absolute;
    font-size: 2em;
    line-height: 4.5em;
    width: 4.5em;
    text-align: center;
    display: block;
    color: #fff;
    z-index: 4;
    background-image: url('./assets/financial-house.svg');
    background-position: center;
    background-size: 3em;
  }

  > .label {
    display: inline;
    line-height: 1em;
    z-index: 4;
    position: absolute;
    top: 0.1em;
    left: 51%;
    font-size: 10px;
    color: white;

    &.inner {
      top: 1.05em;
    }
  }
}

// Media queries
@media (max-width: 768px) {
  .visible-sm-only {
    display: block;
  }
}

.visible-sm-only {
  display: none;
}
</style>
